import {Component, OnInit} from '@angular/core';
import { LocationService } from "../../location.service";
import { Router} from "@angular/router";
import { LocalStorageService } from "../../../local-storage.service";
import { StoreService } from "../store.service";
import { StoreOrderService } from "../../../stores/store-order/store-order.service";
import { IntegrationPaymentService } from '../../payments/integration.payment.service';
import { PaymentStatusFetchBase } from "../../payments/payment-status-fetch-base";
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-payment-progress',
  templateUrl: './payment-progress.component.html',
  styleUrls: ['./payment-progress.component.scss']
})
export class PaymentProgressComponent extends PaymentStatusFetchBase  implements OnInit {

  private fetchInterval: number = 500;
  private maxTimeout: number = 180000;
  private readonly PHYSICAL_PAYMENT_DETAILS = 'physicalPaymentDetails';

  constructor(protected locationService: LocationService,
              protected router: Router,
              protected storageService: LocalStorageService,
              protected storeOrderService: StoreOrderService,
              protected storeService: StoreService,
              protected store: Store<any>,
              protected integrationPaymentService: IntegrationPaymentService
              ) {
    super(locationService, router, storageService, storeOrderService, storeService, store, integrationPaymentService);
  }

  private getPhysicalPaymentDetails() {
    const physicalPaymentDetailsStr = this.storageService.getSavedState(this.PHYSICAL_PAYMENT_DETAILS);
    return JSON.parse(physicalPaymentDetailsStr);
  }

  protected getRedirectUrl(providerFromResponse: string): string {
    const physicalPaymentDetails = this.getPhysicalPaymentDetails();
    const { storeId, orderId, provider, paymentTransactionId, redirectUrl, referenceType } = physicalPaymentDetails;
    let url = redirectUrl
    if (!redirectUrl) {
      url = window.location.origin + "/payment-redirect/" + provider + "/" + storeId + "/" + paymentTransactionId + "/" + orderId + "?referenceType=" + referenceType;
    }
    return url;
  }

  protected getPaymentDetails() {
    return this.getPhysicalPaymentDetails();
  }

  protected onStopFetchPaymentStatus() {
    this.storageService.removeSavedState(this.PHYSICAL_PAYMENT_DETAILS);
  }

  protected getPollingConfig(): { intervalMs: number; timeoutMs: number } {
    return {intervalMs: this.fetchInterval, timeoutMs: this.maxTimeout};
  }

  ngOnInit(): void {
    super.onInit();
  }
}
